import { render, staticRenderFns } from "./wasWatchedTag.vue?vue&type=template&id=519cbf2c&"
import script from "./wasWatchedTag.vue?vue&type=script&lang=js&"
export * from "./wasWatchedTag.vue?vue&type=script&lang=js&"
import style0 from "./wasWatchedTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports